module.exports = __webpack_public_path__ + "img/adaptive-anti-alias.7cc1afc9.png";